import React from 'react'
import styled from 'styled-components'
import GatsbyImage from 'gatsby-image'

import { SiteLink } from '../shared/SiteLink'
import ReviewStarsStore from '../shared/ReviewStarsStore'
import { Helmet } from 'react-helmet'
import BreadCrumb from '../shared/BreadCrumb'

const HeadingBlock = ({
  location,
  title,
  pageDescription,
  cta,
  breadcrumbs,
  reviewMessage,
  partnerLogo,
  partnerLogoLink,
  partnerText,
  readMoreRef,
  pageInfo,
  trustpilotStars,
  totalNumberOfReviews,
}) => {
  const viewInfo = () => {
    window.scrollTo({
      top: readMoreRef.current.offsetTop - 100,
      behavior: 'smooth',
    })
  }

  // const linkedData = {
  //   '@context': 'https://schema.org',
  //   '@type': 'BreadcrumbList',
  //   itemListElement: [
  //     {
  //       '@type': 'ListItem',
  //       position: 1,
  //       name: title,
  //       item: `https://www.stoxenergy.com${location.pathname}`,
  //     },
  //   ],
  // }

  return (
    <>
      <HeadingUI>
        {/* <Helmet>
          {linkedData && (
            <script type='application/ld+json'>
              {JSON.stringify(linkedData)}
            </script>
          )}
        </Helmet> */}
        <BreadCrumb>
          {breadcrumbs &&
            breadcrumbs.map((breadcrumb, index) => {
              const { slug } = breadcrumb.target
              return (
                <>
                  <SiteLink to={slug ? slug : ''} key={index}>
                    {slug ? slug : 'home'}
                  </SiteLink>{' '}
                  {' / '}
                </>
              )
            })}
          {breadcrumbs && title}
        </BreadCrumb>

        <HeadingRight>
          <Try>{reviewMessage}</Try>
          {/* <Review
            trustpilotStars={trustpilotStars}
            totalNumberOfReviews={totalNumberOfReviews}
          /> */}
        </HeadingRight>
      </HeadingUI>
      <HeadingWrapper>
        <PageTitle>{title}</PageTitle>
        {pageDescription && (
          <div>
            <PageDescription>{pageDescription}</PageDescription>
            {/* for 'read more' to show, the Information component must exist and be rendered */}
            {cta && (
              <ReadMore pageInfo={pageInfo}>
                <button type='button' onClick={() => viewInfo()}>
                  {cta}
                </button>
              </ReadMore>
            )}
            {partnerText && (
              <PartnerContainer>
                <PartnerWrapper>
                  <PartnerText>{partnerText}</PartnerText>
                  <PartnerLink href={partnerLogoLink}>
                    {partnerLogo && (
                      <PartnerLogo
                        fluid={partnerLogo.fluid}
                        aspectRatio={partnerLogo.fluid.aspectRatio}
                        imgStyle={{ objectFit: 'contain' }}
                        alt={partnerLogo.title}
                      />
                    )}
                  </PartnerLink>
                </PartnerWrapper>
              </PartnerContainer>
            )}
          </div>
        )}
      </HeadingWrapper>
    </>
  )
}

const HeadingUI = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: ${(props) => props.theme.fontSize.m18};
  color: #a2a2a2;
  padding: ${(props) => props.theme.space.marginMobile}vw
    ${(props) => props.theme.space.marginMobile}vw 0;
  letter-spacing: 0.05em;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    font-size: ${(props) => props.theme.fontSize.d12};
    padding: ${(props) => props.theme.space.marginDesktop * 4}vw
      ${(props) => props.theme.space.marginDesktop * 10}vw 0;
  }
`

const HeadingRight = styled.div`
  white-space: nowrap;
  display: flex;
  align-items: center;
`

const Try = styled.div`
  color: black;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    padding-right: ${(props) => props.theme.space.marginDesktop}vw;
    font-size: 0.7638888vw;
  }
`

const Review = styled(ReviewStarsStore)`
  display: none;
  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    text-transform: lowercase;
    letter-spacing: 0.05em;
    display: block;
  }

  @media screen and (-ms-high-contrast: active) and (min-width: ${(props) =>
      props.theme.breakPoints.desktop}),
    screen and (-ms-high-contrast: none) and (min-width: ${(props) =>
      props.theme.breakPoints.desktop}) {
    display: none;
  }
`

const HeadingWrapper = styled.div`
  padding-left: ${(props) => props.theme.space.marginMobile}vw;
  padding-right: ${(props) => props.theme.space.marginMobile}vw;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    padding: 0 ${(props) => props.theme.space.marginDesktop * 12}vw
      ${(props) => props.theme.space.marginDesktop}vw
      ${(props) => props.theme.space.marginDesktop * 12}vw;
  }
`

const PageTitle = styled.h1`
  font-size: 6.666667vw;
  text-align: center;
  padding-top: ${(props) => props.theme.space.marginMobile * 2}vw;
  padding-bottom: ${(props) => props.theme.space.marginMobile / 2}vw;
  width: 60%;
  margin: 0 auto;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    font-size: ${(props) => props.theme.fontSize.d50};
    padding-top: ${(props) => props.theme.space.marginDesktop * 2}vw;
    padding-bottom: ${(props) => props.theme.space.marginDesktop * 1.5}vw;
  }
`

const PageDescription = styled.div`
  font-size: ${(props) => props.theme.fontSize.m23};
  text-align: center;
  line-height: 4.8vw;
  letter-spacing: 0.05em;
  width: 80%;
  margin: auto;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    font-size: ${(props) => props.theme.fontSize.d15};
    padding-bottom: 0.5vw;
    max-width: 42vw;
    line-height: 1.736vw;
    margin: auto;
  }
`

const PartnerContainer = styled.div`
  display: flex;
  justify-content: space-around;
  margin: 0 0 0.5vw;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    margin: 0.8vw 0 0.5vw;
  }
`

const PartnerWrapper = styled.div`
  display: flex;
  align-items: center;
`

const PartnerText = styled.div`
  font-size: ${(props) => props.theme.fontSize.m23};
  line-height: 4.8vw;
  letter-spacing: 0.05em;
  margin: auto;
  padding-right: 2vw;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    font-size: ${(props) => props.theme.fontSize.d15};
    max-width: 42vw;
    line-height: 1;
    padding-right: 0.5vw;
  }
`

const PartnerLink = styled.a`
  display: flex;
  align-items: center;
`

const PartnerLogo = styled(GatsbyImage)`
  height: 4vw;
  width: ${({ aspectRatio }) => aspectRatio * 4}vw;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    height: 1vw;
    width: ${({ aspectRatio }) => aspectRatio}vw;
  }
`

const ReadMore = styled.div`
  display: ${(props) => (props.pageInfo ? 'block' : 'none')};
  font-size: ${(props) => props.theme.fontSize.m23};
  letter-spacing: 0.05em;
  text-align: center;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    font-size: ${(props) => props.theme.fontSize.d12};
  }

  button {
    margin: 2vw 4vw 2vw;
    color: #a2a2a2;
    font-size: inherit;
    cursor: pointer;
    display: inline-block;
    text-transform: lowercase;
    ${(props) => props.theme.underline('#a2a2a2', '0.05em')}

    @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
      margin: 0 ${(props) => props.theme.space.marginDesktop}vw;
    }
  }
`

export default HeadingBlock
